import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TicketType {
  id: string;
  name: string;
  description?: string;
  created_at?: string;
}

export const useTicketTypes = () => {
  const { data: types, isLoading, error } = useQuery({
    queryKey: ['ticket-types'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('ticket_types')
        .select('id, name, description')
        .order('name');

      if (error) throw error;
      return data as TicketType[];
    },
  });

  return { types, isLoading, error };
};
